import { AutocompleteField } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { currencyOptions } from "shared-utils";

import { MESSAGES } from "./message-definitions";

export const ReportingCurrencySelect = ({
  initialValue,
  error,
  disabled,
  onChange,
  helperText,
}: {
  initialValue?: string;
  error?: string;
  disabled?: boolean;
  onChange: (item: { id: string; text: string }) => void;
  helperText: string;
}) => {
  const intl = useIntl();

  return (
    <AutocompleteField
      name="accountingCurrency"
      label={intl.formatMessage(MESSAGES.reportingCurrencyFieldLabel)}
      placeholder={intl.formatMessage(MESSAGES.reportingCurrencyFieldPlaceholder)}
      helperText={helperText}
      disabled={disabled}
      error={error}
      options={currencyOptions}
      initialValue={initialValue}
      onChange={(id) => {
        const currency = currencyOptions.find((currency) => currency.id === id);
        if (currency) {
          onChange(currency);
        }
      }}
    />
  );
};
